module.exports = __webpack_public_path__ + "static/media/croquis_01.f89f4726.jpg";